/* hs-eslint ignored failing-rules */

/* eslint-disable no-prototype-builtins */
'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import { ADDITIONAL_PROPERTY_FLAG } from '../../../utils/schemaUtils';
import { getParamRowId } from '../../../utils/idUtils';
export default class WrapIfAdditional extends Component {
  render() {
    const {
      children,
      id,
      schema
    } = this.props;
    const hasAdditionalProperties = schema.hasOwnProperty(ADDITIONAL_PROPERTY_FLAG);

    if (!hasAdditionalProperties) {
      return children;
    }

    return /*#__PURE__*/_jsx("div", {
      "data-test-id": `schema-field-${getParamRowId(id)}`,
      children: children
    });
  }

}
WrapIfAdditional.propTypes = {
  children: PropTypes.node.isRequired,
  id: PropTypes.string.isRequired,
  schema: PropTypes.object.isRequired
};